import { useDispatch, useSelector } from 'react-redux';
import { getContentKeyAccToLang } from '../../utils/utils';
import dynamicfunction from '../../utils/dynamicfunction';
import { useEffect, useState } from 'react';
import { getMyFunds } from '../../store/actions/fund-action';
import { downloadInvestmentReport, getInvestmentStatement } from '../../store/actions/fund-investment-action';

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { fundsContent } = useSelector((state) => state.content);
  const { my_funds, fund_loading } = useSelector((state) => state.fund);
  const { investment_statements, investment_loading } = useSelector((state) => state.fundInvestment);

  const [selectedFunds, setSelectedFunds] = useState(null);

  useEffect(() => {
    dispatch(getMyFunds());
  }, []);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      fundsContent?.web_fund_customer_statement?.data?.attributes,
      key,
      isArabic
    );
  };

  const onPressFund = (fund) => {
    setSelectedFunds(fund)
    dispatch(getInvestmentStatement(fund?.oddoFundId))
  }

const onPressDownload = () => {
  dispatch(downloadInvestmentReport(selectedFunds?.oddoFundId))
}


  return {
    TextWeight,
    isArabic,
    getContentKey,
    direction,
    selectedFunds,
    my_funds,
    onPressFund,
    investment_statements,
    fund_loading,
    investment_loading,
    onPressDownload
  };
};
